import { action } from 'satcheljs';

/**
 * Action invoked when user changes the split view mode from Ribbon, Command bar, or hotkey
 */
export const changeSplitViewMode = action('changeSplitViewMode');
